/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'service-desk',
        title: 'Service Desk',
        type : 'basic',
        link : '/service-desk'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'service-desk',
        title: 'Service Desk',
        type : 'basic',
        link : '/service-desk'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'service-desk',
        title: 'Service Desk',
        type : 'basic',
        link : '/service-desk'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'service-desk',
        title: 'Service Desk',
        type : 'basic',
        link : '/service-desk'
    }
];
